import { render, staticRenderFns } from "./custom_slider.vue?vue&type=template&id=b0f7c650"
import script from "./custom_slider.js?vue&type=script&lang=js&external"
export * from "./custom_slider.js?vue&type=script&lang=js&external"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports